module.exports = __webpack_public_path__ + "img/Arrow_Down.f53731cf.svg";